import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Typography,
  Paper,
  Grid,
  Snackbar,
  Alert,
  FormHelperText,
} from "@mui/material";
import styles from "../../../styles/brsr/general.module.css";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { textError } from "../../../utils/validationMessage";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../utils/companyId";
import ReviewBox from "../../Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import BRSRFile from "../../Common/BRSRFile";

const PolicyManagement = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    policyBoardWebDoc: false,
    policiesTranslatedToProceduresDoc: false,
    policyExtendToValueChainPartnersDoc: false,
    codesCertificationsLabelsStandardsDoc: false,
    commitmentsGoalsTargetsDoc: false,
    performanceAgainstGoalsDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData1, setFormData1] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disabled, setDisabled] = useState(false);

  const [formData, setFormData] = useState({
    policyCoveringPrinciples: {
      principle1: "yes",
      principle2: "yes",
      principle3: "yes",
      principle4: "yes",
      principle5: "yes",
      principle6: "yes",
      principle7: "yes",
      principle8: "yes",
      principle9: "yes",
    },
    boardApprovedPolicies: {
      principle1: "yes",
      principle2: "yes",
      principle3: "yes",
      principle4: "yes",
      principle5: "yes",
      principle6: "yes",
      principle7: "yes",
      principle8: "yes",
      principle9: "yes",
    },
    webLinksForPolicies: {
      principle1: "",
      principle2: "",
      principle3: "",
      principle4: "",
      principle5: "",
      principle6: "",
      principle7: "",
      principle8: "",
      principle9: "",
    },
    policiesTranslatedToProcedures: "Yes",
    policiesExtendToValueChainPartners: {
      principle1: true,
      principle2: true,
      principle3: true,
      principle4: true,
      principle5: true,
      principle6: true,
      principle7: true,
      principle8: true,
      principle9: true,
    },
    codesCertificationsLabelsStandards: "",
    commitmentsGoalsTargets: "",
    performanceAgainstGoals: "",
  });
  const [errors, setErrors] = useState({});

  const type = "SectionB";

  const transformBackendPrinciples = (principles) => {
    if (!principles) return {};
    return Object.keys(principles).reduce((acc, key) => {
      acc[key] = principles[key] ? "yes" : "no";
      return acc;
    }, {});
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/brsr/get?type=${type}&id=${id}`);
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);
        if (response?.data?.data) {
          const backendData =
            response.data.data.BRSRSectionB?.policyAndManagement || {};
          setFormData1(backendData);

          // Transform the backend data to match frontend structure
          const transformedData = {
            policyCoveringPrinciples: transformBackendPrinciples(
              backendData.policyCoveringPrinciples,
            ),
            boardApprovedPolicies: transformBackendPrinciples(
              backendData.boardApprovedPolicies,
            ),
            webLinksForPolicies: backendData.webLinksForPolicies || {},
            policiesTranslatedToProcedures:
              backendData.policiesTranslatedToProcedures || "Yes",
            policiesExtendToValueChainPartners:
              backendData.policiesExtendToValueChainPartners || {},
            codesCertificationsLabelsStandards:
              backendData.codesCertificationsLabelsStandards || "",
            commitmentsGoalsTargets: backendData.commitmentsGoalsTargets || "",
            performanceAgainstGoals: backendData.performanceAgainstGoals || "",
          };

          // Set default values for principles if not present
          const defaultPrinciples = Array.from({ length: 9 }).reduce(
            (acc, _, i) => {
              acc[`principle${i + 1}`] = "yes";
              return acc;
            },
            {},
          );

          setFormData({
            ...transformedData,
            policyCoveringPrinciples: {
              ...defaultPrinciples,
              ...transformedData.policyCoveringPrinciples,
            },
            boardApprovedPolicies: {
              ...defaultPrinciples,
              ...transformedData.boardApprovedPolicies,
            },
            webLinksForPolicies: {
              ...Array.from({ length: 9 }).reduce((acc, _, i) => {
                acc[`principle${i + 1}`] = "";
                return acc;
              }, {}),
              ...transformedData.webLinksForPolicies,
            },
            policiesExtendToValueChainPartners: {
              ...Array.from({ length: 9 }).reduce((acc, _, i) => {
                acc[`principle${i + 1}`] = true;
                return acc;
              }, {}),
              ...transformedData.policiesExtendToValueChainPartners,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setsnackOpen({
          open: true,
          message: "Error loading data",
          severity: "error",
        });
      }
    };

    if (type) {
      fetchData();
    }
  }, [type]);

  const handleChange = (field, subField, value) => {
    setFormData((prevState) => {
      if (subField) {
        return {
          ...prevState,
          [field]: {
            ...prevState[field],
            [subField]: value,
          },
        };
      }
      return { ...prevState, [field]: value };
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  console.log("Form Data:", formData);
  const isValidURL = (url) => {
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*))\\.)+[a-z]{2,}" + // domain name
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$", // fragment locator
      "i",
    );
    return !!urlPattern.test(url);
  };

  const validateForm = () => {
    const newErrors = {};

    // Customer brief validation
    if (!formData.codesCertificationsLabelsStandards.trim()) {
      newErrors.codesCertificationsLabelsStandards = textError;
    }

    if (!formData.commitmentsGoalsTargets.trim()) {
      newErrors.commitmentsGoalsTargets = textError;
    }

    if (!formData.performanceAgainstGoals.trim()) {
      newErrors.performanceAgainstGoals = textError;
    }

    // Validate webLinksForPolicies (1.c)
    Object.entries(formData.webLinksForPolicies).forEach(([key, value]) => {
      if (value.trim() && !isValidURL(value.trim())) {
        if (!newErrors.webLinksForPolicies) newErrors.webLinksForPolicies = {};
        newErrors.webLinksForPolicies[key] = "Invalid URL format";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) {
        return;
      }

      try {
        console.log("form data submit:", formData);
        const payload = {
          policyAndManagement: {
            ...formData1,
            policyCoveringPrinciples: transformPrinciples(
              formData.policyCoveringPrinciples,
            ),
            boardApprovedPolicies: transformPrinciples(
              formData.boardApprovedPolicies,
            ),
            webLinksForPolicies: formData.webLinksForPolicies,
            policiesTranslatedToProcedures:
              formData.policiesTranslatedToProcedures,
            policiesExtendToValueChainPartners:
              formData.policiesExtendToValueChainPartners,
            codesCertificationsLabelsStandards:
              formData.codesCertificationsLabelsStandards,
            commitmentsGoalsTargets: formData.commitmentsGoalsTargets,
            performanceAgainstGoals: formData.performanceAgainstGoals,
          },
          policyAndManagementSubmitted: true,
          type: "SectionB",
        };
        console.log("form data payload", payload);

        const response = await put(`/brsr/update?id=${id}`, payload);

        setsnackOpen({
          open: true,
          message: "Data updated successfully!",
          severity: "success",
        });
        onSave();
      } catch (error) {
        console.error("Error updating BRSR:", error);
        setsnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else onSave();
  };

  // Helper function to transform 'yes'/'no' to booleans
  const transformPrinciples = (principles) => {
    return Object.keys(principles).reduce((acc, key) => {
      acc[key] = principles[key] === "yes";
      return acc;
    }, {});
  };

  const disclosureColPct = downloadMode ? 8 : 14;
  const principleColPct = (100 - disclosureColPct) / 9;

  const disclosureColSx = {
    width: `${disclosureColPct}%`,
    minWidth: 0,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    boxSizing: "border-box",
    px: downloadMode ? 0.5 : 1.25,
    py: downloadMode ? 0.5 : 1,
  };

  return (
    <>
      <p className={styles.subHeading}>I. POLICY AND MANAGEMENT PROCESSES.</p>
      <Box>
        <TableContainer
          component={Paper}
          sx={{
            mb: 3,
            width: "100%",
            maxWidth: "100%",
            ml: downloadMode ? 0 : "1rem",
            boxSizing: "border-box",
            overflowX: "auto",
          }}
        >
          <Table
            size={downloadMode ? "small" : "medium"}
            sx={{
              width: "100%",
              maxWidth: "100%",
              tableLayout: "fixed",
            }}
          >
            <colgroup>
              <col style={{ width: `${disclosureColPct}%` }} />
              {[...Array(9)].map((_, idx) => (
                <col key={idx} style={{ width: `${principleColPct}%` }} />
              ))}
            </colgroup>
            <TableHead>
              <TableRow
                style={{
                  backgroundColor: "#1C486B",
                }}
              >
                <TableCell
                  sx={{
                    ...disclosureColSx,
                    color: "#fff",
                    fontSize: downloadMode ? "12px" : "15px",
                    fontFamily: "Inter",
                    fontWeight: 600,
                    borderRight: "1px solid #fff",
                  }}
                >
                  Disclosure Questions
                </TableCell>
                {[...Array(9)].map((_, idx) => (
                  <TableCell
                    key={idx}
                    align="center"
                    sx={{
                      width: `${principleColPct}%`,
                      minWidth: 0,
                      color: "#fff",
                      fontWeight: 400,
                      fontSize: downloadMode ? "12px" : "15px",
                      fontFamily: "Inter",
                      borderRight: "1px solid #fff",
                    }}
                  >
                    P{idx + 1}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {["policyCoveringPrinciples", "boardApprovedPolicies"].map(
                (field, index) => (
                  <TableRow key={field}>
                    <TableCell
                      sx={{
                        ...disclosureColSx,
                        fontSize: downloadMode ? "11px" : "14px",
                        fontWeight: 600,
                        fontFamily: "Inter",
                        color: "#222222",
                        borderRight: "1px solid #DBDBDB",
                        verticalAlign: "top",
                      }}
                    >
                      <Box component="span" sx={{ display: "block", minWidth: 0 }}>
                        {index === 0
                          ? "1. (a) Whether your entity’s policy/policies cover each principle and its core elements of the NGRBCs."
                          : "1. (b) Has the policy been approved by the Board?"}
                      </Box>
                    </TableCell>
                    {[...Array(9)].map((_, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        sx={{
                          width: `${principleColPct}%`,
                          minWidth: 0,
                          borderRight: "1px solid #DBDBDB",
                        }}
                      >
                        <RadioGroup
                          row
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 0.25,
                          }}
                          value={formData[field][`principle${idx + 1}`] || "no"}
                          disabled={disabled}
                          onChange={(e) =>
                            handleChange(
                              field,
                              `principle${idx + 1}`,
                              e.target.value,
                            )
                          }
                        >
                          <FormControlLabel
                            value="yes"
                            control={<Radio disabled={disabled} />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio disabled={disabled} />}
                            label="No"
                          />
                        </RadioGroup>
                      </TableCell>
                    ))}
                  </TableRow>
                ),
              )}
              <TableRow>
                <TableCell
                  sx={{
                    ...disclosureColSx,
                    fontSize: downloadMode ? "11px" : "14px",
                    fontWeight: 600,
                    fontFamily: "Inter",
                    color: "#222222",
                    borderRight: "1px solid #DBDBDB",
                    verticalAlign: "top",
                  }}
                >
                  <Box component="span" sx={{ display: "block", minWidth: 0 }}>
                    1. (c) Web Link of the Policies, if available
                  </Box>
                </TableCell>
                {[...Array(9)].map((_, idx) => (
                  <TableCell
                    key={idx}
                    align="center"
                    sx={{
                      width: `${principleColPct}%`,
                      minWidth: 0,
                      borderRight: "1px solid #DBDBDB",
                      padding: "1.5px 5px",
                    }}
                  >
                    <TextField
                      fullWidth
                      size="small"
                      value={
                        formData.webLinksForPolicies[`principle${idx + 1}`] ||
                        ""
                      }
                      disabled={disabled}
                      multiline
                      placeholder="Link"
                      onChange={(e) =>
                        handleChange(
                          "webLinksForPolicies",
                          `principle${idx + 1}`,
                          e.target.value,
                        )
                      }
                      sx={{
                        width: "100%",
                        minWidth: 0,
                        "& .MuiOutlinedInput-root": {
                          width: "100%",
                          minWidth: 0,
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                      }}
                    />
                    <FormHelperText error>
                      {errors.webLinksForPolicies?.[`principle${idx + 1}`] ||
                        ""}
                    </FormHelperText>
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "policyBoardWebDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            2. Whether the entity has translated the policy into procedures.
          </p>
          <RadioGroup
            disabled={disabled}
            sx={{ marginLeft: "1.2rem", marginTop: "-1rem" }}
            row
            value={formData.policiesTranslatedToProcedures}
            onChange={(e) =>
              handleChange(
                "policiesTranslatedToProcedures",
                null,
                e.target.value,
              )
            }
          >
            <FormControlLabel
              value="Yes"
              control={<Radio disabled={disabled} />}
              label="Yes"
            />
            <FormControlLabel
              value="No"
              control={<Radio disabled={disabled} />}
              label="No"
            />
          </RadioGroup>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "policiesTranslatedToProceduresDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            3. Do the enlisted policies extend to your value chain partners?
            (Yes/No)
          </p>
          <Grid container spacing={2} sx={{ marginLeft: "0.3rem" }}>
            {[...Array(9)].map((_, idx) => (
              <Grid item xs={4} key={idx}>
                <Box display="flex" alignItems="center" gap={2}>
                  {/* Principle Text */}
                  <Typography
                    sx={{
                      color: "#000000",
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}
                  >
                    Principle {idx + 1}
                  </Typography>
                  {/* Radio Buttons */}
                  <RadioGroup
                    row
                    value={
                      formData.policiesExtendToValueChainPartners[
                        `principle${idx + 1}`
                      ]
                        ? "true"
                        : "false"
                    }
                    disabled={disabled}
                    onChange={(e) =>
                      handleChange(
                        "policiesExtendToValueChainPartners",
                        `principle${idx + 1}`,
                        e.target.value === "true",
                      )
                    }
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio disabled={disabled} />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio disabled={disabled} />}
                      label="No"
                    />
                  </RadioGroup>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "policyExtendToValueChainPartnersDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            4. Name of the National & International
            codes/certificates/labels/standards (e.g. Forest Stewardship
            Council, Fairtrade, Rainforest Alliance, Trustea) standards (e.g. SA
            8000, OHSAS, ISO, BIS) adopted by your entity and mapped to each
            principle.
          </p>
          <TextField
            minRows={3}
            multiline
            disabled={disabled}
            style={{
              width: "100%",
              padding: "8px",
              background: "transparent",
              margin: "-1rem 0rem 0rem 0.6rem",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.codesCertificationsLabelsStandards}
            onChange={(e) =>
              handleChange(
                "codesCertificationsLabelsStandards",
                null,
                e.target.value,
              )
            }
            error={!!errors.codesCertificationsLabelsStandards}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-1rem",
                }}
              >
                {errors.codesCertificationsLabelsStandards}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "codesCertificationsLabelsStandardsDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            5. Specific commitments, goals and targets set by the entity with
            defined timelines, if any.
          </p>
          <TextField
            minRows={3}
            multiline
            disabled={disabled}
            style={{
              width: "100%",
              padding: "8px",
              background: "transparent",
              margin: "-1rem 0rem 0rem 0.6rem",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.commitmentsGoalsTargets}
            onChange={(e) =>
              handleChange("commitmentsGoalsTargets", null, e.target.value)
            }
            error={!!errors.commitmentsGoalsTargets}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-1rem",
                }}
              >
                {errors.commitmentsGoalsTargets}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "commitmentsGoalsTargetsDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            6. Performance of the entity against the specific commitments, goals
            & targets along with reasons in case the same are not met.
          </p>
          <TextField
            minRows={3}
            multiline
            disabled={disabled}
            style={{
              width: "100%",
              padding: "8px",
              background: "transparent",
              margin: "-1rem 0rem 0rem 0.6rem",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.performanceAgainstGoals}
            onChange={(e) =>
              handleChange("performanceAgainstGoals", null, e.target.value)
            }
            error={!!errors.performanceAgainstGoals}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-1rem",
                }}
              >
                {errors.performanceAgainstGoals}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData: formData1,
            setFormData: setFormData1,
            errors,
            setErrors,
            open,
            setOpen,
            Uploadkey: "performanceAgainstGoalsDoc",
            ml: 2,
            mt: "-1.5rem",
            removeUpload,
          }}
        />

        {!hide && (
          <>
            {brsrReview ? (
              <Box sx={{ ml: "1rem", width: "98.5%" }}>
                <ReviewBox
                  url={`/brsr/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        )}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity || "info"}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message || "No message provided"}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default PolicyManagement;
